<template>
  <page-header-wrapper>
    <a-card :bordered="false" title="企业认证引导海报">
      <a-alert
        type="info"
        show-icon
        style="margin-bottom:20px"
        message="未认证用户从探索页进入「企业认证」时展示的引导图（App 广告位 type=18）。建议整图含标题与插画，底部「立即认证」按钮由客户端叠加。"
      />
      <a-spin :spinning="loading">
        <div class="poster-editor">
          <div class="poster-preview">
            <img v-if="form.thumb" :src="form.thumb" alt="引导海报预览" />
            <span v-else>未配置海报</span>
            <div class="poster-action">立即认证</div>
          </div>
          <div class="poster-settings">
            <h3>海报图片</h3>
            <file-upload :value="form.thumb" type="image" :count="1" @change="v => form.thumb = v" />
            <p class="hint">建议约 750×1334px（宽×高），单张不超过 2MB。保存后 App 下次进入该页生效。</p>
            <a-form-model-item label="启用">
              <a-switch :checked="Number(form.status) === 1" @change="v => form.status = v ? 1 : 0" />
            </a-form-model-item>
            <a-button
              type="primary"
              :disabled="!loaded"
              :loading="saving"
              v-hasPermi="['dkmall:cert-guide-poster:edit']"
              @click="save"
            >保存引导海报</a-button>
            <a-button style="margin-left:12px" :disabled="saving" @click="load">刷新</a-button>
          </div>
        </div>
      </a-spin>
    </a-card>
  </page-header-wrapper>
</template>
<script>
import request from '@/utils/request'
const url = '/dkmall/cert-guide-poster'
export default {
  name: 'CertGuidePoster',
  data() {
    return { loading: false, loaded: false, saving: false, form: { thumb: '', status: 1 } }
  },
  created() { this.load() },
  methods: {
    async load() {
      this.loading = true
      this.loaded = false
      try {
        const res = await request({ url, method: 'get' })
        this.form = Object.assign({ thumb: '', status: 1 }, res.data || {})
        this.loaded = true
      } finally {
        this.loading = false
      }
    },
    async save() {
      if (!this.loaded) return
      if (Number(this.form.status) === 1 && !this.form.thumb) {
        return this.$message.warning('请先上传海报')
      }
      this.saving = true
      try {
        await request({
          url,
          method: 'put',
          data: { thumb: this.form.thumb || '', status: Number(this.form.status) }
        })
        this.$message.success('引导海报已保存')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>
<style scoped>
.poster-editor { display: flex; gap: 32px; flex-wrap: wrap; }
.poster-preview {
  width: 280px; height: 498px; position: relative;
  display: flex; align-items: center; justify-content: center;
  background: #f5f5f5; overflow: hidden; border-radius: 8px;
}
.poster-preview img { width: 100%; height: 100%; object-fit: cover; }
.poster-action {
  position: absolute; bottom: 28px; left: 24px; right: 24px;
  height: 44px; line-height: 44px; text-align: center;
  background: #e60012; color: #fff; border-radius: 22px; font-weight: 600;
}
.poster-settings { flex: 1; min-width: 260px; max-width: 680px; }
.hint { color: #8c8c8c; line-height: 1.8; margin: 12px 0 20px; }
</style>
